import {TypedFormControls} from '../../../core/forms/form-controls.model'
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms'
import {Observable} from 'rxjs'

export type ControlType =
  | 'SINGLE_SELECT_RADIO'
  | 'SINGLE_SELECT_TILES'
  | 'SINGLE_SELECT_DROPDOWN'
  | 'MULTIPLE_SELECT_CHECKBOXES'
  | 'MULTIPLE_SELECT_TILES'
  | 'OPEN_TEXT_FIELD'
  | 'STEPPER'

export type Question = {
  id: string
  label: string
  required: boolean
  type: ControlType
  order: number
  options?: Options
  error?: string
}

export interface Answer {
  questionId: string
  answerIds?: string[]
  answerValue?: string
  additionalInformation?: string
}

export enum AnswerModelType {
  SINGLE_ANSWER = 'SINGLE_ANSWER',
  MULTI_ANSWER = 'MULTI_ANSWER',
}

export type Options = StepperOptions | SelectOptions

export type StepperOptions = {min: number; max: number; step?: number}

export type SelectOptions = SelectOption[]

export type SelectOption = {key: string; value: string; requireAdditionalInformation: boolean}

export interface AnswerFormGroup extends UntypedFormGroup {
  question: Question
  toAnswer(): Answer
  controls: AnswerControls
  additionalInformationRequired$: Observable<boolean>
  answerControls?: UntypedFormControl[]
}

export type SingleAnswerValue = {
  answer: unknown
  additionalInformation: string
}

export type SingleAnswerControls = TypedFormControls<SingleAnswerValue>
export type MultiAnswerControls = {
  /** User input for the answer of the given question */
  answers: UntypedFormArray
  /** User input for additional information (if required for an answer) */
  additionalInformation: UntypedFormControl
}

export type AnswerControls = SingleAnswerControls | MultiAnswerControls
